__turbopack_context__.v({
  "actions": "NoAvatarCard-module__5I1iuG__actions",
  "badge": "NoAvatarCard-module__5I1iuG__badge",
  "card": "NoAvatarCard-module__5I1iuG__card",
  "content": "NoAvatarCard-module__5I1iuG__content",
  "description": "NoAvatarCard-module__5I1iuG__description",
  "header": "NoAvatarCard-module__5I1iuG__header",
  "iconContainer": "NoAvatarCard-module__5I1iuG__iconContainer",
  "title": "NoAvatarCard-module__5I1iuG__title",
});
